// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.createNoOrLowCostOfferMainDiv {
    width: 100%;
    padding: 0px 32px;
}


.MuiStepLabel-label {
    color: var(--Global-Neutral-Grey-1000, #4F4D55) !important;
    font-family: Poppins !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 400 !important;
}

.MuiStepLabel-label.Mui-active {
    color: var(--Global-Purple-900, #403E9F) !important;
    font-family: Poppins !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 600 !important;
}

.MuiSvgIcon-root.MuiStepIcon-root.Mui-active {
    color: rgba(64, 62, 159, 1);
}

.MuiSvgIcon-root.MuiStepIcon-root.Mui-completed {
    color: rgba(1, 128, 48, 1);
}

.css-1hv8oq8-MuiStepLabel-label.Mui-completed {
    color: var(--Global-Neutral-Grey-1000, #4F4D55) !important;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 600 !important;
}

.stepperIcon {
    height: 25px;
    width: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    border-radius: 50%;
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/offerManagementT/noOrLowCostEmi/createNoOrLowCostEmi/createNoOrLowCostEmi.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;AACrB;;;AAGA;IACI,0DAA0D;IAC1D,+BAA+B;IAC/B,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,mDAAmD;IACnD,+BAA+B;IAC/B,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0DAA0D;IAC1D,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB","sourcesContent":[".createNoOrLowCostOfferMainDiv {\n    width: 100%;\n    padding: 0px 32px;\n}\n\n\n.MuiStepLabel-label {\n    color: var(--Global-Neutral-Grey-1000, #4F4D55) !important;\n    font-family: Poppins !important;\n    font-size: 14px !important;\n    font-style: normal !important;\n    font-weight: 400 !important;\n}\n\n.MuiStepLabel-label.Mui-active {\n    color: var(--Global-Purple-900, #403E9F) !important;\n    font-family: Poppins !important;\n    font-size: 14px !important;\n    font-style: normal !important;\n    font-weight: 600 !important;\n}\n\n.MuiSvgIcon-root.MuiStepIcon-root.Mui-active {\n    color: rgba(64, 62, 159, 1);\n}\n\n.MuiSvgIcon-root.MuiStepIcon-root.Mui-completed {\n    color: rgba(1, 128, 48, 1);\n}\n\n.css-1hv8oq8-MuiStepLabel-label.Mui-completed {\n    color: var(--Global-Neutral-Grey-1000, #4F4D55) !important;\n    font-family: Poppins;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600 !important;\n}\n\n.stepperIcon {\n    height: 25px;\n    width: 25px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    border-radius: 50%;\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
